<div class="row usage-info" *ngIf="usageBucketModel">
  <div class="col-12 col-md-8" *ngIf="usageBucketModel?.usageBucket?.bucket?.data && !isPayGoType">
    <div class="row">
      <div class="col-6">
        <h3 class="inline-block m-r-xs">
          {{ usageBucketModel?.usageBucket?.bucket?.data?.usedTotal }}
          <span *ngIf="usageBucketModel?.usageBucket?.bucket?.data?.usedTotal !== unlimitedData">{{
            usageBucketModel?.usageBucket?.bucket?.data?.uomUsed
          }}</span>
        </h3>
        <p class="small inline-block">
          <span *ngIf="usageBucketModel?.usageBucket?.bucket?.data?.includedTotal"
            >{{ symbolConstants.SLASH }}
            {{ usageBucketModel?.usageBucket?.bucket?.data?.includedTotal }}</span
          >
          <span
            *ngIf="
              usageBucketModel?.usageBucket?.bucket?.data?.includedTotal &&
              usageBucketModel?.usageBucket?.bucket?.data?.includedTotal !== unlimitedData
            "
            >{{ usageBucketModel?.usageBucket?.bucket?.data?.uomIncluded }}</span
          >
        </p>
      </div>
      <div class="col-6 text-end">
        <p class="small inline-block p-t-sm">{{ contentData?.highSpeedData }}</p>
      </div>
    </div>
    <p-progressBar
      *ngIf="usageBucketModel?.usageBucket?.bucket?.data?.includedTotal !== unlimitedData"
      [value]="usageBucketModel?.usageBucket?.bucket?.data?.usedPercentage"
      [showValue]="false"
    >
    </p-progressBar>
  </div>

  <div class="col-12 col-md-8 m-t-md" *ngIf="usageBucketModel?.usageBucket?.bucket?.payGo">
    <div class="row">
      <div class="col-6">
        <h3 class="inline-block">{{ usageBucketModel?.usageBucket?.bucket?.payGo?.usedTotal }}</h3>
        <p class="small inline-block">
          <span
            >{{ symbolConstants.SLASH }} {{ contentData?.includedTalkAndTextLimit
            }}{{ contentData?.minutesOrText }}</span
          >
        </p>
      </div>
      <div class="col-6 text-end">
        <p class="small inline-block p-t-sm">{{ contentData?.talkAndText }}</p>
      </div>
    </div>
    <p-progressBar
      *ngIf="usageBucketModel?.usageBucket?.bucket?.includedTotal !== unlimitedData"
      [value]="usageBucketModel?.usageBucket?.bucket?.payGo?.usedPercentage"
      [showValue]="false"
    ></p-progressBar>
  </div>

  <ng-container *ngIf="usageBucketModel?.usageBucket?.bucket?.dataPass">
    <div class="col-12 col-md-8 m-t-md" *ngIf="!isDataPassArray(); else isDataPassArraytemplate">
      <div class="row">
        <div class="col-6">
          <h3 class="inline-block m-r-xs">
            {{ usageBucketModel?.usageBucket?.bucket?.dataPass?.usedTotal }}
            <span
              *ngIf="usageBucketModel?.usageBucket?.bucket?.dataPass?.usedTotal !== unlimitedData"
              >{{ usageBucketModel?.usageBucket?.bucket?.dataPass?.uomUsed }}</span
            >
          </h3>
          <p class="small inline-block">
            <span *ngIf="usageBucketModel?.usageBucket?.bucket?.dataPass?.includedTotal"
              >{{ symbolConstants.SLASH }}
              {{ usageBucketModel?.usageBucket?.bucket?.dataPass?.includedTotal }}</span
            >
            <span
              *ngIf="
                usageBucketModel?.usageBucket?.bucket?.dataPass?.includedTotal &&
                usageBucketModel?.usageBucket?.bucket?.dataPass?.includedTotal !== unlimitedData
              "
              >{{ usageBucketModel?.usageBucket?.bucket?.dataPass?.uomIncluded }}</span
            >
          </p>
        </div>
        <div class="col-6 text-end">
          <p class="small inline-block p-t-sm">{{ contentData?.dataPass }}</p>
        </div>
      </div>
      <p-progressBar
        *ngIf="usageBucketModel?.usageBucket?.bucket?.dataPass?.includedTotal !== unlimitedData"
        [value]="usageBucketModel?.usageBucket?.bucket?.dataPass?.usedPercentage"
        [showValue]="false"
      ></p-progressBar>
    </div>

    <ng-template #isDataPassArraytemplate>
      <div
        class="col-12 col-md-8 m-t-md"
        *ngFor="let data of usageBucketModel?.usageBucket?.bucket?.dataPass"
      >
        <div class="row">
          <div class="col-6">
            <h3 class="inline-block m-r-xs">
              {{ data.usedTotal }}
              <span *ngIf="data.usedTotal !== unlimitedData">{{ data.uomUsed }}</span>
            </h3>
            <p class="small inline-block">
              <span *ngIf="data.includedTotal"
                >{{ symbolConstants.SLASH }} {{ data.includedTotal }}</span
              >
              <span *ngIf="data.includedTotal && data.includedTotal !== unlimitedData">{{
                data.uomIncluded
              }}</span>
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="small inline-block p-t-sm">{{ contentData?.dataPass }}</p>
          </div>
        </div>
        <p-progressBar
          *ngIf="data.includedTotal !== unlimitedData"
          [value]="data.usedPercentage"
          [showValue]="false"
        ></p-progressBar>
      </div>
    </ng-template>
    <ng-container>
      <div class="col-12 col-md-8 m-t-md" *ngIf="false">
        <div class="row">
          <div class="col-6">
            <h3 class="inline-block m-r-xs">
              {{ usageBucketModel?.usageBucket?.bucket?.dataTether?.usedTotal }}
              <span
                *ngIf="
                  usageBucketModel?.usageBucket?.bucket?.dataTether?.usedTotal !== unlimitedData
                "
              >
                {{ usageBucketModel?.usageBucket?.bucket?.dataTether?.uomUsed }}</span
              >
            </h3>
            <p class="small inline-block">
              <span *ngIf="usageBucketModel?.usageBucket?.bucket?.dataTether?.includedTotal"
                >{{ symbolConstants.SLASH }}
                {{ usageBucketModel?.usageBucket?.bucket?.dataTether?.includedTotal }}</span
              >
              <span
                *ngIf="
                  usageBucketModel?.usageBucket?.bucket?.dataTether?.includedTotal &&
                  usageBucketModel?.usageBucket?.bucket?.dataTether?.includedTotal !== unlimitedData
                "
                >{{ usageBucketModel?.usageBucket?.bucket?.dataTether?.uomIncluded }}</span
              >
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="small inline-block p-t-sm">{{ contentData?.tetherUsage }}</p>
          </div>
        </div>
        <p-progressBar
          *ngIf="usageBucketModel?.usageBucket?.bucket?.dataTether?.includedTotal !== unlimitedData"
          [value]="usageBucketModel?.usageBucket?.bucket?.dataTether?.usedPercentage"
          [showValue]="false"
        >
        </p-progressBar>
      </div>

      <div
        class="col-12 col-md-8 m-t-md"
        *ngIf="usageBucketModel?.usageBucket?.bucket?.dataStash && showMoreDetails"
      >
        <div class="row">
          <div class="col-6">
            <h3 class="inline-block m-r-xs">
              {{ usageBucketModel?.usageBucket?.bucket?.dataStash?.usedTotal }}
              <span
                *ngIf="
                  usageBucketModel?.usageBucket?.bucket?.dataStash?.usedTotal !== unlimitedData
                "
              >
                {{ usageBucketModel?.usageBucket?.bucket?.dataStash?.uomUsed }}</span
              >
            </h3>
            <p class="small inline-block">
              <span *ngIf="usageBucketModel?.usageBucket?.bucket?.dataStash?.includedTotal"
                >{{ symbolConstants.SLASH }}
                {{ usageBucketModel?.usageBucket?.bucket?.dataStash?.includedTotal }}</span
              >
              <span
                *ngIf="
                  usageBucketModel?.usageBucket?.bucket?.dataStash?.includedTotal &&
                  usageBucketModel?.usageBucket?.bucket?.dataStash?.includedTotal !== unlimitedData
                "
                >{{ usageBucketModel?.usageBucket?.bucket?.dataStash?.uomIncluded }}</span
              >
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="small inline-block p-t-sm">
              {{ contentData?.dataStash }}<sup>{{ contentData?.tm }}</sup>
            </p>
          </div>
        </div>
        <p-progressBar
          *ngIf="usageBucketModel?.usageBucket?.bucket?.dataStash?.includedTotal !== unlimitedData"
          [value]="usageBucketModel?.usageBucket?.bucket?.dataStash?.usedPercentage"
          [showValue]="false"
        >
        </p-progressBar>
      </div>

      <div
        class="col-12 col-md-8 m-t-md"
        *ngIf="usageBucketModel?.usageBucket?.bucket?.minutes && showMoreDetails"
      >
        <div class="row">
          <div class="col-6">
            <h4 class="inline-block m-r-xs">
              {{ usageBucketModel?.usageBucket?.bucket?.minutes?.usedTotal }}
              <span
                *ngIf="usageBucketModel?.usageBucket?.bucket?.minutes?.usedTotal !== unlimitedData"
                >{{ usageBucketModel?.usageBucket?.bucket?.minutes?.uomUsed }}</span
              >
            </h4>

            <p class="small inline-block">
              <span *ngIf="usageBucketModel?.usageBucket?.bucket?.minutes?.includedTotal"
                >{{ symbolConstants.SLASH }}
                {{ usageBucketModel?.usageBucket?.bucket?.minutes?.includedTotal }}</span
              >
              <span
                *ngIf="
                  usageBucketModel?.usageBucket?.bucket?.minutes?.includedTotal &&
                  usageBucketModel?.usageBucket?.bucket?.minutes?.includedTotal !== unlimitedData
                "
                >{{ usageBucketModel?.usageBucket?.bucket?.minutes?.uomIncluded }}</span
              >
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="small inline-block p-t-sm">{{ contentData?.talk }}</p>
          </div>
        </div>
        <p-progressBar
          *ngIf="
            usageBucketModel?.usageBucket?.bucket?.minutes?.includedTotal !== unlimitedData &&
            !isPayGoType
          "
          [value]="usageBucketModel?.usageBucket?.bucket?.minutes?.usedPercentage"
          [showValue]="false"
        ></p-progressBar>
      </div>

      <div
        class="col-12 col-md-8 m-t-md"
        *ngIf="usageBucketModel?.usageBucket?.bucket?.messages && showMoreDetails"
      >
        <div class="row">
          <div class="col-6">
            <h4 class="inline-block m-r-xs">
              {{ usageBucketModel?.usageBucket?.bucket?.messages?.usedTotal }}
              <span
                *ngIf="usageBucketModel?.usageBucket?.bucket?.messages?.usedTotal !== unlimitedData"
                >{{ usageBucketModel?.usageBucket?.bucket?.messages?.uomUsed }}</span
              >
            </h4>
            <p class="small inline-block">
              <span *ngIf="usageBucketModel?.usageBucket?.bucket?.messages?.includedTotal"
                >{{ symbolConstants.SLASH }}
                {{ usageBucketModel?.usageBucket?.bucket?.messages?.includedTotal }}</span
              >
              <span
                *ngIf="
                  usageBucketModel?.usageBucket?.bucket?.messages?.includedTotal &&
                  usageBucketModel?.usageBucket?.bucket?.messages?.includedTotal !== unlimitedData
                "
                >{{ usageBucketModel?.usageBucket?.bucket?.messages?.uomIncluded }}</span
              >
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="small inline-block p-t-sm">{{ contentData?.text }}</p>
          </div>
        </div>
        <p-progressBar
          *ngIf="
            usageBucketModel?.usageBucket?.bucket?.messages?.includedTotal !== unlimitedData &&
            !isPayGoType
          "
          [value]="usageBucketModel?.usageBucket?.bucket?.messages?.usedPercentage"
          [showValue]="false"
        >
        </p-progressBar>
      </div>

      <div class="col-12">
        <p
          class="text-magenta m-t-md"
          *ngIf="usageBucketModel.usageBucketcount > usageBucketModel?.seeMoreLimit"
        >
          <a
            href="javascript:void(0)"
            [hidden]="
              showMoreDetails && usageBucketModel?.usageBucketcount > usageBucketModel?.seeMoreLimit
            "
            (click)="showUsageDetails()"
            >{{ contentData?.seeMore }}</a
          >
          <a
            href="javascript:void(0)"
            [hidden]="!showMoreDetails"
            (click)="showUsageDetails()"
            id="cta-default-29"
            >{{ contentData?.seeLess }}</a
          >
        </p>
      </div>

      <div class="row m-t-xl" *ngIf="fraudLockIndicator && showIndicator">
        <div class="col-9 col-md-10 n-padding-r">
          <p class="alert-text">
            <i class="fa fa-flag def alert-icon"></i>{{ fraudLockedNotification }}
          </p>
        </div>
        <div class="col-3 col-md-1 text-end">
          <a class="hover-magenta" id="cta-default-1_notification">
            <i class="fa fa-times def" (click)="removeFraudIndicatorAlert()"></i>
          </a>
        </div>
      </div> </ng-container
  ></ng-container>
</div>
